
export function formatoFechaSpanish (fecha) {
    
    if (fecha != "" && fecha != null) {
      var anio = fecha.substring(6, 6);
    var mes = fecha.substring(3, 2);
    var dia = fecha.substring(0, 2);
      try {
        var m = new Date(fecha);
        var dateString =
          ("0" + m.getUTCDate()).slice(-2) +
          "-" +
          ("0" + (m.getUTCMonth() + 1)).slice(-2) +
          "-" +
          m.getUTCFullYear();
        return dateString;
      } catch (error) {
        console.error(error);
      }
    } else {
      return "";
    }
  }

  export function formatoFecha(fecha) {
    if (fecha == null) {
      return null;
    } else {
      if ((fecha != "") & (fecha != "0001-01-01T00:00:00")) {
        try {
          var m = new Date(fecha);
          var dateString =
            m.getUTCFullYear() +
            "-" +
            ("0" + (m.getUTCMonth() + 1)).slice(-2) +
            "-" +
            ("0" + m.getUTCDate()).slice(-2);
          return dateString;
        } catch (error) {
          console.error(error);
        }
      } else {
        return "";
      }
    }
  }

  

  export function diferenciaMenorAXDias(fecha1, fecha2, dias) {
    // Convertir las fechas a objetos Date
    const date1 = new Date(fecha1);
    const date2 = new Date(fecha2);  
    // Calcular la diferencia en milisegundos
    const diferenciaEnMilisegundos = Math.abs(date2.getTime() - date1.getTime());  
    // Convertir la diferencia de milisegundos a días
    const milisegundosEnUnDia = 24 * 60 * 60 * 1000;
    const diferenciaEnDias = diferenciaEnMilisegundos / milisegundosEnUnDia;
    const dif = diferenciaEnDias < dias;
   
    // Verificar si la diferencia es menor a 7 días
    return dif;
  }

   //format datetime to dd/mm/yyyy hh:mm:ss
  export function formatoFechaHoras(date) {
    if (date == null) {
      return "";
    }
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear(),
      hour = d.getHours(),
      minute = d.getMinutes(),
      second = d.getSeconds();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    if (hour < 10) hour = "0" + hour;
    if (minute < 10) minute = "0" + minute;
    if (second < 10) second = "0" + second;

    return (
      [day, month, year].join("/") + " " + hour + ":" + minute + ":" + second
    );
  }


  export function formatoNumero(num) {
    
    if (num=== null || num === undefined) {
      return "0,00";
    }
    //contamos la cantidad de puntos sin match
    var puntos = (num.toString().match(/\./g) || []).length;
    //contamos la cantidad de comas
    var comas = (num.toString().match(/\,/g) || []).length;
    //si hay mas de una coma
    if (comas > 0) {
      if (puntos > 0) {
        num = num.replace(/\./g, "");
        num = num.replace(/\,/g, ".");
      } else {
        num = num.replace(/\,/g, ".");
      }
    }
    try {
      num = parseFloat(num);
    } catch (error) {
      return num;
    }

    return num.toLocaleString("es-BO", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  export function quitarformatoNumero(num) {
    var n = num.replace(/\./g, "");
    n = n.replace(/\,/g, ".");
    return n;
  }

  export function esNulo(elemento) {
    if (elemento ==="" || elemento === null || elemento === undefined)
        return true;
    else 
        return false;
  }

